import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { usePrincipal } from '@/common/principal/PrincipalContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useState } from 'react';

export const ApprDecisionDialog = ({ data, closeDialog }) => {

  const { principal } = usePrincipal();
  const rsrc = useRsrc();

  const [error, setError] = useState(false);
  const [comment, setComment] = useState('Per Standard Operating Procedure (SOP)');

  const saveDecision = (approved) => {
    if (comment === '') {
      setError(true);
      return;
    }

    const type = approved ? 'APPR_ACCEPT' : 'APPR_REJECT';
    const events = data.runIds.map(runId => {
      return {
        type,
        data: comment,
        msg: (type === 'APPR_ACCEPT' ? 'Approval' : 'Rejection') + ' Decision Submitted',
        ack: true,
        recBy: principal.username,
        cat: 'APPR',
        runId
      }
    })

    rsrc.save('skdr', 'EVENT', events).then(() => {
      closeDialog({ type });
    })
  }

  return (
    <Dialog onClose={() => closeDialog()} open={true} fullWidth maxWidth="md">
      <DialogTitle>{data.title}</DialogTitle>
      <DialogContent>
        <TextField
          label="Comment"
          fullWidth
          multiline
          minRows={3}
          maxRows={10}
          error={error}
          value={comment}
          onChange={(event) => setComment(event.target.value)}
          helperText={error ? 'Please provide a reason for Approving or Rejecting ' : 'Reason for Approving/Rejecting'}
        />
          
      </DialogContent>
      <DialogActions>
        <Button onClick={() => closeDialog()}>Cancel</Button>
        <Button onClick={() => saveDecision(false)} data-test-id="appr-decision-reject">Reject</Button>
        <Button onClick={() => saveDecision(true)} data-test-id="appr-decision-approve">Approve</Button>
      </DialogActions>
    </Dialog>
  )
}